import { forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from '@/helpers/translate';
import { useSearchZustandStore } from '@/helpers/searchctx.js';
import HofPlusIcon from '@/components/icons/hofplus';

/**
 * WEA-157 — Filtre "Legend +" (= abonnement HOF+). Visible pour TOUT LE MONDE (visiteurs inclus) :
 * simulation d'abonnement. Exclusif avec "HOF -X%".
 *
 * Actif -> graphql `hof:['hof']` + `hofRate:'full'` : restreint aux espaces HOF et applique la
 * tarification abonné côté back (15% de base ; HOF_LEGEND_DISCOUNT_PERCENT — ex. 30% — sur les mois
 * offerts par l'hôte, selon les dates de recherche). Le prix du viewer (byViewer) reflète cette
 * simulation et `dataByCategory.appliedDiscountPercent` porte le % exact par espace pour le badge.
 */
const LegendPlus = forwardRef(({ onValid }, ref) => {
  const { t } = useTranslation();
  const active = useSearchZustandStore((state) => state.hofFilter === 'legendplus');

  useImperativeHandle(ref, () => ({
    getValue: () => (useSearchZustandStore.getState().hofFilter === 'legendplus' ? 'legendplus' : null),
    getOutput: () => ({
      keySlug: 'hofdiscount',
      slug: 'hofdiscount',
      url: 'legendplus',
      values: 'legendplus',
      graphql: { hof: ['hof'], hofRate: 'full' },
    }),
    clearValue: () => useSearchZustandStore.setState((state) => (
      state.hofFilter === 'legendplus' ? { hofFilter: null } : {}
    )),
    setIsOpenModal: () => null,
    isSameDefault: () => useSearchZustandStore.getState().hofFilter !== 'legendplus',
  }), []);

  const toggle = () => {
    useSearchZustandStore.setState((state) => ({
      hofFilter: state.hofFilter === 'legendplus' ? null : 'legendplus',
    }));
    onValid?.();
  };

  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={toggle}
      className={`flex justify-center items-center w-full text-sm rounded-lg transition-all duration-200 py-[8px] px-[8px] group ${active ? 'text-white bg-purple hover:bg-purple/80' : 'text-white bg-purple-6 hover:bg-purple/70'}`}
    >
      <HofPlusIcon className={`mr-2 size-5 transition-colors duration-200 ${active ? 'text-white' : 'text-purple-4/70 group-hover:text-white'}`} />
      <span className="truncate whitespace-nowrap transition-colors duration-200">{t('search:legendPlus.title')}</span>
    </button>
  );
});

export default LegendPlus;
